import { Percent } from 'lucide-react'
import { formatCurrency } from '@/utils/format-currency'
import { Badge } from '@/components/ui/Badge'
import { getEffectiveProbability, usesStageDefaultProbability } from '../deals-constants'
import type { Deal } from '@/types'

export function DealValueSummary({ deal }: { deal: Deal }) {
  const probabilidade = getEffectiveProbability(deal)
  const forecast = deal.valor * (probabilidade / 100)
  const storedDiffersFromStage =
    usesStageDefaultProbability(deal.etapa) && deal.probabilidade !== probabilidade

  return (
    <div className="rounded-xl border border-white/[0.06] bg-white/[0.02] p-4 space-y-3">
      <div className="flex items-center justify-between gap-2">
        <p className="text-[10px] font-medium uppercase tracking-wider text-text-label">
          Valor do negócio
        </p>
        {deal.recorrencia && <Badge variant="info">{deal.recorrencia}</Badge>}
      </div>

      <p className="text-2xl font-bold tabular-nums text-text-primary">
        {formatCurrency(deal.valor)}
      </p>

      <div className="flex items-center gap-3">
        <div className="flex shrink-0 items-center gap-1.5">
          <Percent size={12} className="text-accent" aria-hidden />
          <span className="text-sm font-bold tabular-nums text-accent">{probabilidade}%</span>
        </div>
        <div className="h-1.5 flex-1 overflow-hidden rounded-full bg-white/[0.06]">
          <div
            className="h-full rounded-full bg-accent transition-all"
            style={{ width: `${probabilidade}%` }}
          />
        </div>
      </div>

      {storedDiffersFromStage && (
        <p className="text-[10px] text-text-label">
          Probabilidade da etapa: {probabilidade}% (registro: {deal.probabilidade}%)
        </p>
      )}

      <div className="flex items-center justify-between border-t border-white/[0.06] pt-3">
        <span className="text-xs text-text-label">Forecast ponderado</span>
        <span className="text-sm font-bold tabular-nums text-emerald-400">
          {formatCurrency(forecast)}
        </span>
      </div>
    </div>
  )
}
